import React, { useState, useMemo } from 'react';
import {
  Home as HomeIcon,
  AddTask as AddTaskIcon,
  MonitorHeart as VitalsIcon,
  Description as CccIcon,
  AssignmentInd as DepartmentIcon,
} from '@mui/icons-material';
import CreditScoreIcon from '@mui/icons-material/CreditScore';

import DepartmentLayout from '../Layout/DepartmentLayout';
import Home from './Home';
import PatientInformation from './PatientInformation';
import PatientVitals from './PatientVitals';
import Ccc from './Ccc';
import PatientRegistrationDashboard from './PatientRegistrationDashboard';

export default function Record() {
  // Shared state — Home writes selectedPatient when editing,
  // PatientInformation reads it.
  const [selectedPatient, setSelectedPatient] = useState(null);

  const menuItems = useMemo(() => [
    {
      key: 'RecordsDashboard',
      label: 'Home',
      icon: <CreditScoreIcon />,
      component: PatientRegistrationDashboard,
    },
    {
      key: 'Home',
      label: 'Records',
      icon: <HomeIcon />,
      render: ({ navigate }) => (
        <Home
          onAddNewPatient={() => {
            setSelectedPatient(null);
            navigate('PatientInformation');
          }}
          onEditPatient={(p) => {
            setSelectedPatient(p);
            navigate('PatientInformation');
          }}
        />
      ),
    },
    {
      key: 'PatientInformation',
      label: 'Patient Information',
      icon: <AddTaskIcon />,
      render: ({ navigate }) => (
        <PatientInformation
          selectedPatient={selectedPatient}
          onPatientSaved={() => {
            setSelectedPatient(null);
            navigate('PatientInformation');
          }}
        />
      ),
    },
    { key: 'PatientVitals', label: 'Patient Vitals', icon: <VitalsIcon />, component: PatientVitals },
    { key: 'Ccc',           label: 'CCC',            icon: <CccIcon />,    component: Ccc },
  ], [selectedPatient]);

  return (
    <DepartmentLayout
      departmentId={1}
      departmentName="Medical Records"
      departmentIcon={<DepartmentIcon />}
      menuItems={menuItems}
    />
  );
}
